import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export type TuontiLahdejarjestelma = 'netvisor' | 'procountor'

export interface TuontiLahdejarjestelmaVaihtoehto {
  arvo: TuontiLahdejarjestelma
  nimi: string
}

export interface TuontiLahdejarjestelmaValintaDialogData {
  otsikko: string
  tiedostonNimi: string
  /** Selite sille, miksi valinta kysytään (esim. automaattinen tunnistus epäonnistui) */
  viesti?: string
  vaihtoehdot: TuontiLahdejarjestelmaVaihtoehto[]
}

export interface TuontiLahdejarjestelmaValintaDialogResult {
  lahdejarjestelma: TuontiLahdejarjestelma
}

@Component({
  template: `
    <h2 mat-dialog-title>{{ data.otsikko }}</h2>
    <mat-dialog-content>
      <p>
        Tiedosto: <strong>{{ data.tiedostonNimi }}</strong>
      </p>
      @if (data.viesti) {
        <p>{{ data.viesti }}</p>
      }
      <p>Valitse lähdejärjestelmä, josta tiedosto on viety.</p>
      <mat-form-field style="width: 100%;">
        <mat-label>Lähdejärjestelmä</mat-label>
        <mat-select [(value)]="lahdejarjestelma">
          @for (vaihtoehto of data.vaihtoehdot; track vaihtoehto.arvo) {
            <mat-option [value]="vaihtoehto.arvo">{{ vaihtoehto.nimi }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <app-secondary-button mat-dialog-close actionId="Tuontitiedoston lähdejärjestelmädialogi peruuta">Peruuta</app-secondary-button>
      <app-primary-button style="margin-left: 8px;" (click)="jatka()" actionId="Tuontitiedoston lähdejärjestelmädialogi jatka">Jatka</app-primary-button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TuontiLahdejarjestelmaValintaDialog {
  lahdejarjestelma: TuontiLahdejarjestelma

  constructor(
    private _dialogRef: MatDialogRef<TuontiLahdejarjestelmaValintaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TuontiLahdejarjestelmaValintaDialogData,
  ) {
    this.lahdejarjestelma = data.vaihtoehdot[0]?.arvo ?? 'netvisor'
  }

  jatka(): void {
    const result: TuontiLahdejarjestelmaValintaDialogResult = {
      lahdejarjestelma: this.lahdejarjestelma,
    }
    this._dialogRef.close(result)
  }
}
